export default "__VITE_ASSET__CQVbg$Bk__"